var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-link',{attrs:{"variant":"link","href":`${_vm.origin}/app/objectives/${_vm.id}`}},[_vm._v("\n    "+_vm._s(_vm.$t('insights.viewObjective'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }